import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
// reset style sheet
import "@/styles/reset.scss";
// CSS common style sheet
import "@/styles/common.scss";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);
import VideoPlayer from "vue-video-player";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
import "animate.css/animate.min.css";
Vue.use(VideoPlayer);

// import Carousel3d from "vue-carousel-3d";
// Vue.use(Carousel3d);

// Vue.use(animated);

import VueLazyload from "vue-lazyload";
Vue.use(VueLazyload, {
  //完全显示的时候加载
  preLoad: 1,
  //失败时显示的图片
  error: require("./assets/images/error.png"),
  //加载时显示的GIF图
  loading: require("./assets/images/loading.gif"),
  //尝试加载几次
  attempt: 1,
});
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
